var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0745 21.0039L24.8746 22.8125M14.9792 21.7708H9.45833C8.29156 21.7708 7.70817 21.7708 7.26252 21.5437C6.87051 21.3441 6.5518 21.0253 6.35207 20.6333C6.125 20.1877 6.125 19.6043 6.125 18.4375V10.5208C6.125 9.35406 6.125 8.77067 6.35207 8.32502C6.5518 7.93301 6.87051 7.6143 7.26252 7.41457C7.70817 7.1875 8.29156 7.1875 9.45833 7.1875H21.5417C22.7084 7.1875 23.2919 7.1875 23.7375 7.41457C24.1295 7.6143 24.4482 7.93301 24.6479 8.32502C24.875 8.77067 24.875 9.35406 24.875 10.5208V13.4375M24.4653 10.5857L19.1978 14.0974C17.8614 14.9883 17.1931 15.4339 16.4708 15.607C15.8325 15.7599 15.1671 15.7599 14.5289 15.607C13.8066 15.4339 13.1383 14.9883 11.8018 14.0974L6.2786 10.4152M23.8333 19.1667C23.8333 20.6049 22.6674 21.7708 21.2292 21.7708C19.7909 21.7708 18.625 20.6049 18.625 19.1667C18.625 17.7284 19.7909 16.5625 21.2292 16.5625C22.6674 16.5625 23.8333 17.7284 23.8333 19.1667Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconFooter);
export default __webpack_public_path__ + "static/media/email_icon-footer.ee297aad91cb2aa773b98e2c98d77fe8.svg";
export { ForwardRef as ReactComponent };